import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type BlogPostRecord = NonNullable<
  ResultOf<typeof blogPostRecordQuery>["blogPost"]
>;

export const blogPostRecordQuery = graphql(`
  query BlogPostRecord($id: ID!, $locale: String) {
    blogPost(id: $id, locale: $locale) {
      id
      slug
      locale
      title
      excerpt
      body_html
      body_images {
        ...MediaFields
      }
      hero_image {
        ...MediaFields
      }
      seo_image {
        ...MediaFields
      }
      reading_time_minutes
      audience
      published_at
      is_published
      author {
        id
        name
        role
        image {
          ...MediaFields
        }
      }
      tags {
        id
        name
        slug
      }
      translations {
        locale
        title
        excerpt
        body_html
      }
      available_locales
      created_at
      updated_at
    }
  }
`);
